import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { useTranslation } from '../contexts/LanguageContext';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t('privacy.seo.title')}
        description={t('privacy.seo.description')}
        keywords={['privacy policy', 'data protection', 'personal information']}
        ogUrl="/privacy"
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto bg-opacity-15 bg-sky-800 rounded-xl shadow-md p-8 mt-20"
      >
        <h1 className="text-3xl font-bold text-white mb-6">
          {t('privacy.title')}
        </h1>
        <div className="prose text-primary-200 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.intro.title')}
            </h2>
            <p>
              {t('privacy.intro.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.collect.title')}
            </h2>
            <p>{t('privacy.collect.text')}</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>{t('privacy.collect.item1')}</li>
              <li>{t('privacy.collect.item2')}</li>
              <li>{t('privacy.collect.item3')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.use.title')}
            </h2>
            <p>{t('privacy.use.text')}</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>{t('privacy.use.item1')}</li>
              <li>{t('privacy.use.item2')}</li>
              <li>{t('privacy.use.item3')}</li>
              <li>{t('privacy.use.item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.protect.title')}
            </h2>
            <p>
              {t('privacy.protect.text')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.rights.title')}
            </h2>
            <p>{t('privacy.rights.text')}</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>{t('privacy.rights.item1')}</li>
              <li>{t('privacy.rights.item2')}</li>
              <li>{t('privacy.rights.item3')}</li>
              <li>{t('privacy.rights.item4')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.contact.title')}
            </h2>
            <p>
              {t('privacy.contact.text')}{' '}
              <a href="mailto:asmaessafi137@gmail.com" className="text-sky-500 hover:text-sky-600">
                asmaessafi137@gmail.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-sky-600 mb-3">
              {t('privacy.updates.title')}
            </h2>
            <p>
              {t('privacy.updates.text')}
            </p>
          </section>
        </div>
      </motion.div>
    </>
  );
};

export default PrivacyPolicy;